import { useEffect, useState } from "react";

/**
 * Same as useState, but persists the value (as JSON) in localStorage under the given key.
 * Falls back to defaultValue if localStorage is unavailable or holds an invalid value.
 */
export function useLocalStorageState(key, defaultValue) {
    const [value, setValue] = useState(() => {
        try {
            const stored = localStorage.getItem(key);
            return stored !== null ? JSON.parse(stored) : defaultValue;
        } catch {
            return defaultValue;
        }
    });

    useEffect(() => {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        } catch {
            // Storage unavailable (e.g. private mode) - keep the in-memory value only
        }
    }, [key, value]);

    return [value, setValue];
}
